/* eslint-disable react/prop-types */
/**
 * @file AltracBattery.jsx
 * @exports AltracBatteryDefault
 */
import React from 'react'
import High from './High'
import Low from './Low'

const AltracBatteryDefault = function AltracBatteryDefault ({
  full,
  half,
  height,
  high,
  low,
  width,
}) {
  return (
    <AltracBattery
      full={full}
      half={half}
      height={height}
      high={high}
      low={low}
      width={width}
    />
  )
}

export default AltracBatteryDefault

const defaultColor = '#284047'

const AltracBattery = function AltracBattery ({
  full,
  half,
  height,
  high,
  low,
  width,
}) {
  return (
    <svg
      height={height}
      viewBox='0 0 75 75'
      width={width}
    >
      <description>altrac internal battery icon</description>
      <title>altrac internal battery</title>
      <g
        id='altrac-battery-icon'
        style={{
          transform: 'translate(12px, -380px) scale(1.5)',
        }}
      >
        <path
          d='M 13.2,264.2 H 20.6 v 2.1 h 5.8 v 29.6 H 7.4 v -29.6 h 5.8 z'
          style={{
            fill: 'none',
            stroke: defaultColor,
            strokeWidth: 2,
            strokeLinecap: 'butt',
            strokeLinejoin: 'round',
            strokeMiterlimit: 4,
          }}
        />
        {full && (
          <rect
            y='26.9'
            x='8.9'
            height='5.8'
            width='16'
            style={{ fill: defaultColor }}
          />
        )}
        {(full || high) && (
          <rect
            y='274.8'
            x='8.9'
            height='5.8'
            width='16'
            style={{ fill: defaultColor }}
          />
        )}
        {(full || high || half) && (
          <rect
            y='281.7'
            x='8.9'
            height='5.8'
            width='16'
            style={{ fill: defaultColor }}
          />
        )}
        {(full || high || half || low) && (
          <rect
            y='288.5'
            x='8.9'
            height='5.8'
            width='16'
            style={{ fill: defaultColor }}
          />
        )}

      </g>
      {!!high && (
        <g id='high' transform='translate(46,36) scale(.4)'>
          <High />
        </g>
      )}

      {!!low && (
        <g id='low' transform='translate(46,36) scale(.4)'>
          <Low />
        </g>
      )}
    </svg>
  )
}
